import { createSlice } from '@reduxjs/toolkit';

const flaggedSlice = createSlice({
  name: 'flagged',
  initialState: {
    flaggedSubmissions: [],
  },
  reducers: {
    addFlaggedSubmission: (state, action) => {
      const exists = state.flaggedSubmissions.find(item => item.id === action.payload.id);
      if (!exists) {
        state.flaggedSubmissions.push({
          ...action.payload,
          flaggedAt: new Date().toLocaleDateString()
        });
      }
    },
    removeFlaggedSubmission: (state, action) => {
      state.flaggedSubmissions = state.flaggedSubmissions.filter(
        item => item.id !== action.payload
      );
    },
    clearFlaggedSubmissions: (state) => {
      state.flaggedSubmissions = [];
    },
  },
});

export const { 
  addFlaggedSubmission, 
  removeFlaggedSubmission, 
  clearFlaggedSubmissions 
} = flaggedSlice.actions;

// Selectors
export const selectFlaggedSubmissions = (state) => state.flagged.flaggedSubmissions;
export const selectIsSubmissionFlagged = (state, submissionId) => 
  state.flagged.flaggedSubmissions.some(item => item.id === submissionId);

export default flaggedSlice.reducer;
